module.exports={
  "search": "Search",
  "searchDown": "Our search service is down. Please try again later or contact support.",
  "searchSaturated": "We are sorry, but our search service received too many requests. Please try again in a second."
}
